import { render, staticRenderFns } from "./BatchTransferAccounts.vue?vue&type=template&id=49e0a689&scoped=true&"
import script from "./BatchTransferAccounts.vue?vue&type=script&lang=js&"
export * from "./BatchTransferAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BatchTransferAccounts.vue?vue&type=style&index=0&id=49e0a689&lang=less&scoped=true&"
import style1 from "./BatchTransferAccounts.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e0a689",
  null
  
)

export default component.exports